import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdvancedMemberSearchForm from "./components/AdvancedMemberSearchForm";
import {
  EMPTY_ADVANCED_MEMBER_SEARCH_CRITERIA,
  applyMemberSearchCriteriaPatch,
  hasAdvancedMemberSearchCriteria,
  type MemberSearchCriteria,
} from "./memberSearchQuery";
import { useMemberSearchCatalogOptions } from "./useMemberSearchCatalogOptions";
import { buildMemberSearchResultsPath } from "../../utils/memberSearchNavigation";

const AdvancedMemberSearchPage: React.FC = () => {
  const navigate = useNavigate();
  const [criteria, setCriteria] = useState<MemberSearchCriteria>(
    EMPTY_ADVANCED_MEMBER_SEARCH_CRITERIA
  );
  const [showValidation, setShowValidation] = useState(false);

  const {
    memberFirms,
    regions,
    locations,
    practiceIndustries,
    officeLocations,
    isLoadingOfficeLocations,
  } = useMemberSearchCatalogOptions(criteria.firm?.id);

  const handleCriteriaChange = (patch: Partial<MemberSearchCriteria>) => {
    setCriteria((previous) => {
      const next = applyMemberSearchCriteriaPatch(previous, patch);
      if (patch.firm !== undefined) {
        const previousFirmId = previous.firm?.id?.trim() || undefined;
        const nextFirmId = patch.firm?.id?.trim() || undefined;
        if (nextFirmId !== previousFirmId) {
          next.officeLocation = undefined;
          next.firm = nextFirmId ? patch.firm : undefined;
        }
      }
      return next;
    });

    if (showValidation && hasAdvancedMemberSearchCriteria({ ...criteria, ...patch })) {
      setShowValidation(false);
    }
  };

  const handleSearch = () => {
    if (!hasAdvancedMemberSearchCriteria(criteria)) {
      setShowValidation(true);
      return;
    }
    navigate(buildMemberSearchResultsPath(criteria));
  };

  return (
    <div className="relative flex min-h-[calc(100dvh-7.5rem)] w-full items-center justify-center py-10 md:min-h-[calc(100dvh-8rem)]">
      <div className="relative z-10 w-full max-w-[812px] px-4 md:px-0">
        <AdvancedMemberSearchForm
          criteria={criteria}
          onChange={handleCriteriaChange}
          onSearch={handleSearch}
          showValidation={showValidation}
          firms={memberFirms}
          regions={regions}
          locations={locations}
          practiceIndustries={practiceIndustries}
          officeLocations={officeLocations}
          officeLocationsLoading={isLoadingOfficeLocations}
        />
      </div>
    </div>
  );
};

export default AdvancedMemberSearchPage;
